import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=4c167a1c&"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports